export const SET_BANNER = 'setBanner'
export const SET_BANNERS = 'setBanners'
export const SET_BANNER_INDEX = 'setBannerIndex'
export const BANNER_RESET_STATE = 'bannerResetState'
export const REMOVE_BANNER = 'removeBanner'